import axios from '../utils/axios'
import Qs from 'qs'
//通过商品标签获取商品数据  /blade-business/producttag/getProductsByTagId    get
export const TagProduct = (token, val) => {
  return new Promise((resolve, reject) => {
    let url = '/api/blade-business/producttag/getProductsByTagId';
    axios.defaults.headers.common['Blade-Auth'] = token;
    axios.get(url, {
        params: {
          tagId: val
        }
      })
      .then((data) => {
        var result = data;
        return resolve(result)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

// 根据渠道获取活动配置  /content/front/get-activity-by-channel    请求方式：get    入参：channel   传入channel，0:pc  1:app
export const activityPics = (token) => {
  return new Promise((resolve, reject) => {
    let url = '/api/blade-content/content/front/get-activity-by-channel';
    axios.defaults.headers.common['Blade-Auth'] = token;
    axios.get(url, {
        params: {
          channel: 1
        }
      })
      .then((data) => {
        var result = data;
        return resolve(result)
      })
      .catch((err) => {
        reject(err)
      })
  })
}





// let datas = {
//   buyChannel: 1,
//   paymentMethod:8,
//   id: sessionStorage.getItem("orderId"),
// };
// 订单支付  /blade-order/order/payOrderH5   post
export const payOrder=(datas)=>{
  return new Promise((resolve,reject)=>{
      let url ='api/blade-order/order/payOrderH5';
      axios({
          headers:{
              'Content-Type':'application/x-www-form-urlencoded',
          },
          url:url,
          method:"post",
          data:Qs.stringify(datas)
      })
      .then((data)=>{
          var result = data;
          return resolve(result)
      })
      .catch((err)=>{
          reject(err)
      })
  })
}

// 通过订单编号获取订单详情  /order/detailH5    http://localhost:8081/#/PayAnother?orderId=1648573574360907778  https://html5.3akx.cn/#/PayAnother?orderId=1648573574360907778   1648971642407272449
export const getOrderDetail = (id) => {
  return new Promise((resolve, reject) => {
    let url = '/api/blade-order/order/detailH5';
    axios.get(url, {
        params: {
          id: id
        }
      })
      .then((data) => {
        var result = data;
        return resolve(result)
      })
      .catch((err) => {
        reject(err)
      })
  })
}



// 微信返回接口  
export const getWX = (code,tenantId) => {
  return new Promise((resolve, reject) => {
    let url = '/api/blade-resource/paysite/chatLogin';
    axios.get(url, {
      params: {
        code: code,
        tenantId:tenantId
      }
    })
      .then((data) => {
        var result = data;
        return resolve(result)
      })
      .catch((err) => {
        reject(err)
      })
  })
}


// WEBPACK FOOTER //
// ./src/api/product.js